/** @jsx jsx */
import {jsx, css} from '@emotion/react'

const Footer = () => {
    return (
        <footer
            css={css`
                padding: 2rem 1rem;
                background: #f1f3ff;
                text-align: center;
                color: #1f2a47;
            `}
        >
            Startpage.com © {new Date().getFullYear()}
        </footer>
    )
}

export default Footer
